import { render, staticRenderFns } from "./LiveChannel.vue?vue&type=template&id=bf03ad0c&scoped=true"
import script from "./LiveChannel.vue?vue&type=script&lang=js"
export * from "./LiveChannel.vue?vue&type=script&lang=js"
import style0 from "./LiveChannel.vue?vue&type=style&index=0&id=bf03ad0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf03ad0c",
  null
  
)

export default component.exports